module.exports = __webpack_public_path__ + "static/media/t02ru.ea9bde40.pdf";